<template>
  <div>
    <div>{{ $t('Tender members') }}:</div>
    <ul class="tender-members-tooltip-list">
      <li v-for="member in members" :key="member.user_id">
        {{ member.name || member.email }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'TenderMembersInTooltip',
    props: {
      members: Array,
    },
  };
</script>

<style scoped lang="scss">
  .tender-members-tooltip-list {
    text-align: left;
    margin-left: 0;
    padding-left: 20px;
    margin-bottom: 4px;
  }
</style>
